<template>
  <div class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-section about">
          <h4>关于我们</h4>
          <p><a href="/news">查看公告</a></p>
        </div>
        <div class="footer-section contact">
          <h4>联系方式</h4>
          <div class="contact-info">
            <p>
              <span class="label">电话:</span>
              <span class="value">123-456-7890</span>
            </p>
            <p>
              <span class="label">邮箱:</span>
              <span class="value">contact@example.com</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p>浙ICP备2021037195号-1</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #111111;
  color: #fff;
  padding: 20px 0 20px;
  margin-top: 50px;

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;

    .footer-content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 20px;
      padding: 0 100px;

      .footer-section {
        h4 {
          margin-bottom: 15px;
          font-size: 20px;
          color: #ffd04b;
        }

        p {
          margin: 8px 0;
          font-size: 18px;
          color: #bdc3c7;

          a {
            color: #bdc3c7;
            text-decoration: none;

            &:hover {
              color: #ffd04b;
            }
          }
        }

        // 关于我们 - 左对齐
        &.about {
          // text-align: left;
        }

        // 联系方式 - 右侧，但内容左对齐
        &.contact {
          text-align: left;

          h4 {
            text-align: left;
            margin-left: 30px;
          }

          .contact-info {
            p {
              display: flex;
              align-items: center;
              margin: 8px 0;
              text-align: left;

              .label {
                display: inline-block;
                width: 45px; // 固定宽度，保证冒号对齐
                flex-shrink: 0;
                color: #bdc3c7;
              }

              .value {
                color: #bdc3c7;
              }
            }
          }
        }
      }
    }
  }
  .footer-bottom {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #34495e;

    p {
      margin: 0;
      font-size: 16px;
      color: #95a5a6;
    }
  }
}
</style>
